export default __webpack_public_path__ + "static/custom_img_1-9c99ae9eb06bac89186bc7bdc437ead9.png";